<template>
    <div id="company">
        <v-container>
            <v-row class="text-center">
                <v-col cols="12">
                    <v-btn @click="goBack" color="primary"><v-icon dark left>mdi-arrow-left</v-icon> zurück</v-btn>
                </v-col>
            </v-row>
            <v-row class="text-center">
                <v-col cols="12">
                    <img v-if="company.logo" :src="`https://backend.suche-regional.at/storage/companies/${company.logo}`" class="company-logo">
                    <h2>{{ company.title }}</h2>
                    <h3 v-if="company.name">{{ company.name }}</h3>
                    <p>{{ company.street }} &bull; {{ company.postcode }} {{ company.city }}<br>
                        <a :href="`mailto:${company.email}`">{{ company.email }}</a>
                        <span v-if="company.web"> &bull; <a :href="`${company.web}`" target="_blank">{{ company.web }}</a></span>
                        <span v-if="company.phone"><br><a :href="`tel:${company.phone}`">{{ company.phone }}</a></span>
                        <span v-if="company.mobile"> &bull; <a :href="`tel:${company.mobile}`">{{ company.mobile }}</a></span>
                    </p>
                    <p v-if="company.shop">
                        <strong>Online Shop:</strong><br>
                        <a :href="`${company.shop}`" target="_blank">{{ company.shop }}</a>
                    </p>
                    <div v-if="company.description != ''">
                        <nl2br tag="p" :text="`${company.description}`" />
                    </div>
                </v-col>
            </v-row>
        </v-container>
    </div>
</template>

<script>
    import { dataService } from "../shared";
    import Nl2br from 'vue-nl2br';
    import { navigation } from "../mixins/navigation";

    export default {
        name: "Company",
        props: ['id'],
        mixins: [navigation],
        components: {
            Nl2br
        },
        data() {
            return {
                company: {}
            }
        },
        methods: {
            async load()
            {
                this.company = await dataService.getCompany(this.id);
            },
        },
        async created() {
            await this.load();
        }
    }
</script>

<style scoped>

</style>

<style scoped>

</style>